import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSeparateVideoVoice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSeparateVideoVoice"><Path fillRule="evenodd" clipRule="evenodd" d="M14 22H12.5V19H2V5H12.5V2H14V22ZM4 17H6.5V15.5H4V17ZM8.5 17H11V15.5H8.5V17ZM4 8.5H6.5V7H4V8.5ZM8.5 8.5H11V7H8.5V8.5Z" fill="currentColor"/><Path d="M20 19H18.5V5H20V19Z" fill="currentColor"/><Path d="M17 16H15.5V8H17V16Z" fill="currentColor"/><Path d="M23 14.5H21.5V9.5H23V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSeparateVideoVoice;
